import React from "react";
import { isContentAllowedForAgeRange } from "@/helpers/ageRange.utils";
import { getCMSApiRoute } from "../api.util";
import { useSelector } from "react-redux";
import _ from "lodash";

export function useArtistMovies({
  fetchDelay = 0,
  artistName,
  initialData,
  initialPage,
} = {}) {
  const ageRange = useSelector((state) => state.Auth.ageRange) || 120;
  const [items, setItems] = React.useState(initialData || []);
  const [hasMore, setHasMore] = React.useState(true);
  const [isLoading, setIsLoading] = React.useState(false);
  const [page, setPage] = React.useState(initialPage || 1);
  const limit = 20;

  const loadMovies = async (page) => {
    const controller = new AbortController();
    const { signal } = controller;

    try {
      setIsLoading(true);

      if (page > 1) {
        await new Promise((resolve) => setTimeout(resolve, fetchDelay));
      }

      const response = await fetch(
        getCMSApiRoute(
          "content?" +
            new URLSearchParams({
              pageNumber: page,
              pageIndex: limit,
              artist: artistName,
            }).toString()
        ),
        {
          signal,
        }
      );

      if (!response.statusText === "ok") {
        throw new Error("Network response was not ok");
      }

      const { data } = await response.json();

      setHasMore(data.total > page * limit);
      setItems((prevItems) =>
        _.uniqBy(
          [
            ...prevItems,
            ...data?.results?.filter((x) =>
              isContentAllowedForAgeRange(x.ageRange, ageRange, {
                allowEmpty: false,
              })
            ),
          ],
          (x) => x._id
        )
      );
    } catch (error) {
      console.log(error);
      if (error.name === "AbortError") {
        console.log("Fetch aborted");
      } else {
        console.error("There was an error with the fetch operation:", error);
      }
    } finally {
      setIsLoading(false);
    }
  };

  React.useEffect(() => {
    loadMovies(page);
  }, []);

  const onLoadMore = () => {
    const newOffset = page + 1;

    setPage(newOffset);
    loadMovies(newOffset);
  };

  return {
    items,
    hasMore,
    isLoading,
    onLoadMore,
  };
}
